
/* Static-page vanilla JS — replaces React for prerendered pages */
(function(){
  // Generic accordion handler — works for Radix Accordion (used on /faq, home FAQ
  // section) and the custom Shop-page FAQ buttons. Both follow the pattern:
  //   button[aria-controls=panelId][aria-expanded] + div#panelId[hidden]
  // Toggle aria-expanded, hidden, and data-state on the button + content + the
  // closest ancestor that also carries data-state (the Radix AccordionItem
  // wrapper, which uses data-[state=open]:bg-primary/5 for its open style).
  // Inline height:auto overrides Radix height animation that depends on a CSS
  // var Radix only sets at runtime in React.
  document.querySelectorAll('button[aria-controls][aria-expanded]').forEach(function(btn){
    var panelId = btn.getAttribute('aria-controls');
    var panel = document.getElementById(panelId);
    if(!panel) return; // dialog triggers etc. without a sibling panel — skip
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var willOpen = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if(btn.hasAttribute('data-state')){
        btn.setAttribute('data-state', willOpen ? 'open' : 'closed');
      }
      panel.setAttribute('data-state', willOpen ? 'open' : 'closed');
      if(willOpen){
        panel.removeAttribute('hidden');
        panel.style.height = 'auto';
        panel.style.maxHeight = 'none';
      } else {
        panel.setAttribute('hidden', '');
        panel.style.height = '';
        panel.style.maxHeight = '';
      }
      // Walk up to the nearest ancestor (other than the panel itself) that
      // carries data-state, and sync it. This lights up Radix
      // data-[state=open]:bg-primary/5 styling on the AccordionItem.
      var ancestor = btn.parentElement;
      while(ancestor && ancestor !== document.body){
        if(ancestor !== panel && ancestor.hasAttribute('data-state')){
          ancestor.setAttribute('data-state', willOpen ? 'open' : 'closed');
          break;
        }
        ancestor = ancestor.parentElement;
      }
    });
  });

  // Mobile menu toggle (replaces React state in static snapshots).
  // Also swaps the hamburger icon for an X when open, mirroring React behavior.
  var MENU_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" class="w-5 h-5"><line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="18" y2="18"/></svg>';
  var X_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" class="w-5 h-5"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
  document.querySelectorAll('[data-mobile-menu-trigger]').forEach(function(trigger){
    trigger.addEventListener('click', function(){
      var panel = document.querySelector('[data-mobile-menu-panel]');
      if(!panel) return;
      var willOpen = panel.classList.contains('hidden');
      panel.classList.toggle('hidden', !willOpen);
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      trigger.setAttribute('aria-label', willOpen ? 'Close menu' : 'Open menu');
      trigger.innerHTML = willOpen ? X_ICON : MENU_ICON;
    });
  });

  // Mobile sticky CTA: hide once #offer is in view (matches React MobileStickyCta logic)
  var sticky = document.querySelector('[data-testid="mobile-sticky-cta"]');
  var offer = document.getElementById('offer');
  if(sticky && offer){
    var update = function(){
      var y = window.scrollY + 80;
      var offerTop = offer.getBoundingClientRect().top + window.scrollY;
      var hidden = y >= offerTop;
      sticky.classList.toggle('translate-y-0', !hidden);
      sticky.classList.toggle('translate-y-full', hidden);
    };
    window.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update);
    update();
  }

  // In-page anchor scrolling: lazy images / below-fold content can shift the
  // target's position after the browser has already started its native instant
  // scroll, so the first tap on the sticky CTA lands too high. Intercept all
  // same-page anchor links, then scroll-and-recompute until the target stops
  // moving (layout is stable).
  function smoothScrollToHash(hash){
    var id = hash.replace(/^#/, '');
    var el = document.getElementById(id);
    if(!el) return false;
    var headerOffset = 16;
    function targetY(){
      return el.getBoundingClientRect().top + window.scrollY - headerOffset;
    }
    window.scrollTo({ top: targetY(), behavior: 'smooth' });
    // Re-correct as content settles (images decode, fonts load, lazy chunks mount).
    var attempts = 0;
    var lastY = -1;
    var iv = setInterval(function(){
      var y = targetY();
      // If the target has moved more than 4px since last check, re-scroll.
      if(Math.abs(y - lastY) > 4){
        window.scrollTo({ top: y, behavior: attempts === 0 ? 'smooth' : 'auto' });
      }
      lastY = y;
      attempts++;
      if(attempts >= 12) clearInterval(iv); // ~1.8s of monitoring
    }, 150);
    // Also nudge on window 'load' (covers lazy images that finish after 1.8s).
    if(document.readyState !== 'complete'){
      window.addEventListener('load', function(){
        window.scrollTo({ top: targetY(), behavior: 'auto' });
      }, { once: true });
    }
    return true;
  }
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if(!a) return;
    var href = a.getAttribute('href');
    if(!href || href === '#') return;
    if(smoothScrollToHash(href)){
      e.preventDefault();
      if(history.replaceState) history.replaceState(null, '', href);
    }
  }, true);

  // FAQ category filter (data-faq-filter-group / data-faq-filter / data-faq-item-group / data-faq-category)
  document.querySelectorAll('[data-faq-filter-group]').forEach(function(group){
    var groupId = group.getAttribute('data-faq-filter-group');
    var btns = group.querySelectorAll('[data-faq-filter]');
    var items = document.querySelectorAll('[data-faq-item-group="'+groupId+'"]');
    btns.forEach(function(btn){
      btn.addEventListener('click', function(){
        var cat = btn.getAttribute('data-faq-filter');
        // Toggle button active styles (covers both /faq and /shop FAQ button class sets)
        btns.forEach(function(b){
          var on = b === btn;
          b.classList.toggle('bg-primary', on);
          b.classList.toggle('text-primary-foreground', on);
          b.classList.toggle('border-primary', on);
          b.classList.toggle('shadow-sm', on);
          b.classList.toggle('bg-muted', !on && b.hasAttribute('data-faq-filter') && groupId === 'page-faq');
          b.classList.toggle('text-muted-foreground', !on);
          if(groupId === 'shop-faq'){
            b.classList.toggle('bg-card/40', !on);
            b.classList.toggle('border-border', !on);
          }
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        // Show/hide items
        items.forEach(function(item){
          var itemCat = item.getAttribute('data-faq-category');
          var show = cat === 'all' || itemCat === cat;
          item.classList.toggle('hidden', !show);
        });
      });
    });
  });

  // BuyBox: one-time tier selection + AJAX add-to-cart
  document.querySelectorAll('[data-testid="buy-box"]').forEach(function(buybox){
    var ACTIVE_TIER = ['border-primary','bg-primary/[0.04]'];
    var INACTIVE_TIER = ['border-border'];
    var ACTIVE_DOT = ['border-primary','bg-primary'];
    var INACTIVE_DOT = ['border-foreground/30'];
    var state = { tier: '3' };

    function updatePriceAndCta(){
      var tierEl = buybox.querySelector('[data-bb-onetime-tier="'+state.tier+'"]');
      if(!tierEl) return;
      var priceEl = buybox.querySelector('[data-bb-price]');
      var ctaTotal = buybox.querySelector('[data-bb-cta-total]');
      if(priceEl) priceEl.textContent = '$' + tierEl.getAttribute('data-bb-perbottle');
      if(ctaTotal) ctaTotal.textContent = tierEl.getAttribute('data-bb-total');
    }

    function setTier(tier){
      state.tier = tier;
      buybox.querySelectorAll('[data-bb-onetime-tier]').forEach(function(card){
        var on = card.getAttribute('data-bb-onetime-tier') === tier;
        ACTIVE_TIER.forEach(function(c){ card.classList.toggle(c, on); });
        INACTIVE_TIER.forEach(function(c){ card.classList.toggle(c, !on); });
        var dot = card.querySelector('[data-bb-tier-dot]');
        var check = card.querySelector('[data-bb-tier-check]');
        if(dot){
          ACTIVE_DOT.forEach(function(c){ dot.classList.toggle(c, on); });
          INACTIVE_DOT.forEach(function(c){ dot.classList.toggle(c, !on); });
        }
        if(check) check.classList.toggle('hidden', !on);
      });
      updatePriceAndCta();
    }

    buybox.querySelectorAll('[data-bb-onetime-tier]').forEach(function(btn){
      btn.addEventListener('click', function(){ setTier(btn.getAttribute('data-bb-onetime-tier')); });
    });

    var cta = buybox.querySelector('[data-bb-cta]');
    if(cta){
      cta.addEventListener('click', function(e){
        e.preventDefault();
        var tierEl = buybox.querySelector('[data-bb-onetime-tier="'+state.tier+'"]');
        if(!tierEl) return;
        var vid = tierEl.getAttribute('data-bb-variant-id');
        var qty = parseInt(tierEl.getAttribute('data-bb-quantity') || '1', 10);
        var fallback = tierEl.getAttribute('data-bb-checkout');
        if(!vid){ if(fallback) window.location.href = fallback; return; }
        var origLabel = cta.innerHTML;
        cta.disabled = true;
        cta.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: qty })
        }).then(function(r){
          if(!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function(){
          window.location.href = '/checkout';
        }).catch(function(){
          cta.disabled = false;
          cta.removeAttribute('aria-busy');
          cta.innerHTML = origLabel;
          if(fallback) window.location.href = fallback;
        });
      });
    }
    setTier(state.tier);
  });

  // Email subscribe forms (any form posting to /api/subscribe)
  document.querySelectorAll('form').forEach(function(form){
    if(!form.querySelector('input[type="email"]')) return;
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var email = form.querySelector('input[type="email"]');
      var btn = form.querySelector('button[type="submit"]');
      if(!email || !email.value) return;
      var orig = btn ? btn.textContent : '';
      if(btn){ btn.disabled = true; btn.textContent = 'Subscribing…'; }
      fetch('/api/subscribe', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({email: email.value})
      }).then(function(){
        if(btn){ btn.textContent = 'Subscribed ✓'; }
        email.value = '';
      }).catch(function(){
        if(btn){ btn.disabled = false; btn.textContent = orig; }
      });
    });
  });
})();
